module.exports = __webpack_public_path__ + "img/demo3.f011704b.jpg";